// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectsFeed_container__TS90P","pagination":"ProjectsFeed_pagination__2Gfqe"};